import { ref } from 'vue'
import { defineStore } from 'pinia'
import { Device } from '@twilio/voice-sdk'

export const useDeviceStore = defineStore('device', () => {
  const device = ref<Device | null>(null)

  return { device }
})
